var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IconBaseSvg } from "../icon-base";
var FilterIcon = function (props) { return (React.createElement(IconBaseSvg, __assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("g", { strokeWidth: "0" },
        React.createElement("path", { d: "M8.7355844,8.77896296 L8.7355844,16.2094815 C8.7355844,16.4062222 8.81202586,16.5914074 8.95216854,16.7315556 L14.0041195,21.7834074 C14.1427807,21.9235556 14.3291438,22 14.5258769,22 C14.6230583,22 14.7181657,21.9813333 14.8094214,21.9431111 C15.0861513,21.8287407 15.2645147,21.5611852 15.2645147,21.2616296 C15.2645147,21.2616296 13.9401949,12.4360173 15.2645147,8.77896296 C16.5888346,5.12190859 21.7836677,3.25925926 21.7836677,3.25925926 C21.9955112,3.04740741 22.0580273,2.73155556 21.9433651,2.45481481 C21.8289992,2.17807407 21.5614541,2 21.2619103,2 L2.73818887,2 C2.43834872,2 2.1710999,2.17807407 2.0564377,2.456 C1.9420718,2.73155556 2.00458788,3.04622222 2.21613518,3.25925926 L8.7355844,8.77896296 Z", id: "path-1" })))); };
export default FilterIcon;
//# sourceMappingURL=FilterIcon.js.map